var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVoiceChip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_643_2937)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32.5,
    r: 27.5,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0065 31.9938C20.0522 31.7533 20.0913 31.506 20.1435 31.2654C20.7109 28.7393 22.9674 26.935 25.4718 27.0018C28.0348 27.0753 30.2001 28.9599 30.6305 31.5394C30.9044 33.17 30.5131 34.6469 29.5022 35.9434C29.4566 35.9968 29.4175 36.057 29.3522 36.1372C31.4588 36.1372 33.5392 36.1372 35.6458 36.1372C35.5936 36.0703 35.5545 36.0102 35.5153 35.9567C34.2501 34.2994 33.924 32.4616 34.6675 30.5103C35.424 28.5388 36.8849 27.376 38.9327 27.0686C41.8154 26.6342 44.5415 28.7594 44.9458 31.6998C45.3567 34.6736 43.3871 37.447 40.524 37.9081C40.198 37.9616 39.8588 37.9883 39.5262 37.995C34.8436 38.0017 30.1544 38.0017 25.4718 37.995C22.837 37.995 20.6978 36.2508 20.1239 33.6579C20.0783 33.444 20.0457 33.2235 20 33.0029C20.0065 32.6621 20.0065 32.328 20.0065 31.9938ZM43.211 32.4884C43.2045 30.4635 41.6132 28.8329 39.6371 28.8396C37.6675 28.8396 36.0697 30.4835 36.0697 32.5017C36.0697 34.5133 37.674 36.1505 39.6501 36.1505C41.6197 36.1505 43.2175 34.5066 43.211 32.4884ZM21.7935 32.5017C21.8 34.5266 23.3913 36.1505 25.3674 36.1505C27.337 36.1439 28.9348 34.4999 28.9348 32.4884C28.9283 30.4702 27.324 28.8396 25.3544 28.8396C23.3848 28.8396 21.787 30.4835 21.7935 32.5017Z",
    fill: "#FF8832"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_643_2937",
    x: 0,
    y: 0,
    width: 65,
    height: 65,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_643_2937"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_643_2937"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_643_2937",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoiceChip);
export default __webpack_public_path__ + "static/media/voice-chip.c827b8a628622cf3c760322ff1a0baf2.svg";
export { ForwardRef as ReactComponent };